module.exports = __webpack_public_path__ + "static/media/GridwiseCombinationHorizontalLight.4c8b2ef2.svg";